import { Container } from "@mantine/core";
import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  DefaultSuccessNotification,
  generateRandomString,
} from "../../Lib/Methods";
import { AppContext } from "../Wrapper";
import MegaLoader from "../../Components/MegaLoader";
const LoginFromAdmin: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const { userToken } = useParams();
  localStorage.removeItem("t");
  localStorage.removeItem("a");
  setTimeout(() => {
    localStorage.setItem("t", userToken as string);
    localStorage.setItem("a", generateRandomString(44));
    setTimeout(() => {
      context?.reloadProfile();
      navigate("/d/profile");
      DefaultSuccessNotification("Logged in as user");
    }, 500);
  }, 500);

  useEffect(() => {
    if (context?.profile && context.profile.id) {
    }
  }, [context?.profile]);
  return (
    <Container size="lg">
      {context?.isLoadingProfile && (
        <div className="flex-row align-center justify-center width-100">
          <MegaLoader />
        </div>
      )}
    </Container>
  );
};

export default LoginFromAdmin;
